import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SnUnauthorizedGuard, SignUpEnabledGuard, SsoEnabledGuard } from './guards';
import { ActivateView } from './views/activate';
import { AuthView } from './views/auth';
import { ChangePasswordComponent } from './views/change-password';
import { ResetConfirmView } from './views/reset-confirm';
import { ResetPasswordView } from './views/reset-password';
import { SignInView } from './views/sign-in';
import { SingleSignOnView } from './views/single-sign-on/single-sign-on.view';
import { SsoDeniedView } from './views/sso-denied/sso-denied.view';
import { SsoErrorView } from './views/sso-error/sso-error.view';
import { SsoMobileDeniedComponent } from './views/sso-mobile-denied/sso-mobile-denied.component';
import { SsoMobileSamlComponent } from './views/sso-mobile-saml/sso-mobile-saml.component';
import { SsoMobileSuccessComponent } from './views/sso-mobile-success/sso-mobile-success.component';
import { SsoSuccessView } from './views/sso-success/sso-success.view';

const routes: Routes = [
  {
    path: 'sso',
    canActivate: [],
    component: AuthView,
    children: [
      {
        path: 'mobile/saml/:email',
        canActivate: [SsoEnabledGuard],
        component: SsoMobileSamlComponent,
        data: {
          snTitle: 'Single Sign On',
        },
      },
      {
        path: 'mobile/success/:mobile/:token',
        canActivate: [SsoEnabledGuard],
        component: SsoMobileSuccessComponent,
        data: {
          snTitle: 'Success',
        },
      },
      {
        path: 'mobile/denied',
        canActivate: [SsoEnabledGuard],
        component: SsoMobileDeniedComponent,
        data: {
          snTitle: 'Denied',
        },
      },
      {
        path: 'success',
        canActivate: [SsoEnabledGuard],
        component: SsoSuccessView,
        data: {
          snTitle: 'Success',
        },
      },
      {
        path: 'denied',
        canActivate: [SsoEnabledGuard],
        component: SsoDeniedView,
        data: {
          snTitle: 'Denied',
        },
      },
      {
        path: 'error',
        canActivate: [SsoEnabledGuard],
        component: SsoErrorView,
        data: {
          snTitle: 'Error',
        },
      },
      {
        path: ':prefix',
        canActivate: [SsoEnabledGuard, SnUnauthorizedGuard],
        component: SingleSignOnView,
        data: {
          snTitle: 'Single Sign On',
        },
      },
    ],
  },
  {
    path: ':app/sso',
    canActivate: [],
    component: AuthView,
    children: [
      {
        path: 'mobile/saml/:email',
        canActivate: [SsoEnabledGuard],
        component: SsoMobileSamlComponent,
        data: {
          snTitle: 'Single Sign On',
        },
      },
      {
        path: 'mobile/success/:mobile/:token',
        canActivate: [SsoEnabledGuard],
        component: SsoMobileSuccessComponent,
        data: {
          snTitle: 'Success',
        },
      },
      {
        path: 'mobile/denied',
        canActivate: [SsoEnabledGuard],
        component: SsoMobileDeniedComponent,
        data: {
          snTitle: 'Denied',
        },
      },
      {
        path: 'success',
        canActivate: [SsoEnabledGuard],
        component: SsoSuccessView,
        data: {
          snTitle: 'Success',
        },
      },
      {
        path: 'denied',
        component: SsoDeniedView,
        canActivate: [SsoEnabledGuard],
        data: {
          snTitle: 'Denied',
        },
      },
      {
        path: ':prefix',
        canActivate: [SsoEnabledGuard, SnUnauthorizedGuard],
        component: SingleSignOnView,
        data: {
          snTitle: 'Single Sign On',
        },
      },
    ],
  },
  {
    path: 'auth',
    canActivate: [SnUnauthorizedGuard],
    component: AuthView,
    children: [
      {
        path: 'sign-in',
        component: SignInView,
        data: {
          snTitle: 'Sign In',
        },
      },
      {
        path: 'reset',
        component: ResetPasswordView,
        data: {
          snTitle: 'Reset Password',
        },
      },
      {
        path: 'reset/confirm/:uid/:token',
        component: ResetConfirmView,
        data: {
          snTitle: 'Reset Confirm',
        },
      },
      {
        path: 'change/:uid/:token',
        component: ChangePasswordComponent,
        data: {
          snTitle: 'Change Password',
        },
      },
      {
        path: 'activate/:uid/:token',
        component: ActivateView,
        data: {
          snTitle: 'Activate',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
